import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import useSettings from "../../hooks/Settings";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Location from '../../hooks/Location';
import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import Tooltip from "../common/Tooltip";
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { Auth } from '../../StateManagment/Auth';
import { useFirestoreNoCompagny } from "../../firebase/useFirestore";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { ActiveMenu } from '../../StateManagment/ActiveMenuItem';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import Hostname from '../../hooks/Hostname';
import getPersonaTerms from '../../helpers/personaTerms';
import usePermissions from '../../hooks/usePermissions';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { isSuperAdminTenant } from '../../utils/superAdminTenant';
import useUnseenUpdates from '../../hooks/useUnseenUpdates';
import UpdatesBadge from '../updates/UpdatesBadge';

// Maps the URL segment after /:client/ to which menu item should be highlighted.
// `active` is the main item key; `sub` is the sub-item key (or '' for a main item).
// Keeps the sidebar highlight in sync with the route, also when navigation comes
// from elsewhere (e.g. the dashboard's "Aanpassen" modal → /analysis).
const MENU_ROUTE_MAP = {
  dashboard: { active: 'dashboard', sub: '' },
  analysis: { active: 'analysis', sub: '' },

  impactstrategy: { active: 'impactstrategy', sub: '' },
  organisationcontext: { active: 'impactstrategy', sub: 'organisationcontext' },
  stakeholders: { active: 'impactstrategy', sub: 'stakeholders' },
  Activities: { active: 'impactstrategy', sub: 'Activities' },
  Mechanisms: { active: 'impactstrategy', sub: 'Mechanisms' },
  effects: { active: 'impactstrategy', sub: 'effects' },

  measurementplan: { active: 'measurementplan', sub: '' },
  storytelling: { active: 'measurementplan', sub: 'storytelling' },
  events: { active: 'measurementplan', sub: 'events' },
  research: { active: 'measurementplan', sub: 'research' },
  questionnaires: { active: 'measurementplan', sub: 'questionnaires' },
  questionairebuilder: { active: 'measurementplan', sub: 'questionnaires' },
  addstandardeffectstoquestionaire: { active: 'measurementplan', sub: 'questionnaires' },
  addindicatorstoquestionaire: { active: 'measurementplan', sub: 'questionnaires' },
  addonstructuredinterview: { active: 'measurementplan', sub: 'questionnaires' },

  personasexplainer: { active: 'personasexplainer', sub: '' },
  personas: { active: 'personas', sub: 'personas' },
  housevisitsoverview: { active: 'personas', sub: 'housevisitsoverview' },
  intakeforms: { active: 'personas', sub: 'intakeforms' },
  materials: { active: 'personas', sub: 'materials' },
  facturatie: { active: 'personas', sub: 'facturatie' },

  portfolio: { active: 'portfolio', sub: '' },
  projects: { active: 'portfolio', sub: 'projects' },
  projectsOverview: { active: 'portfolio', sub: 'projectsOverview' },

  updates: { active: 'updates', sub: '' },
  updatesmailing: { active: 'communication', sub: 'updatesmailing' },
  prullenbak: { active: 'prullenbak', sub: '' },

  communication: { active: 'communication', sub: '' },
  livereports2: { active: 'communication', sub: 'livereports2' },
  impactinbeeld: { active: 'communication', sub: 'impactinbeeld' },
  synchronisations: { active: 'communication', sub: 'synchronisations' },
};

const LeftSideBar = () => {
  // Context
  const [authO] = useContext(Auth)
  const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu)

  // State
  const [open, setOpen] = useState(false)
  const [delayedOpen, setDelayedOpen] = useState(false);
  const [showMeasumentplan, setShowMeasumentplan] = useState(false)
  const [showPersonas, setShowPersonas] = useState(false)
  const [showHouseVisits, setShowHouseVisits] = useState(false)
  const [showCommunication, setShowCommunication] = useState(false)
  const [showFinancing, setShowFinancing] = useState(false)
  const [showPortfolio, setShowPortfolio] = useState(false)
  const [showResearchChildren, setShowResearchChildren] = useState(false) // ⟵ NEW

  // Hooks
  const client = Location()[1]
  const history = useHistory()
  const location = useLocation()
  // Eén aanroep per hook, niet één per veld: zowel Hostname() als useSettings()
  // openen per aanroep hun eigen Firestore-listeners (useSettings o.a. op
  // OutputEffects where Standard == 'true', tientallen tot honderden documenten).
  const host = Hostname()
  const logo = host.Logo
  const hostName = host.Name
  const personaTerms = getPersonaTerms(hostName)
  const settings = useSettings()
  const {
    compagnyName: companyName,
    portfolio,
    personasOn: personas,
    housevisits,
    wervingsacties,
    subscription,
    impactFunctionality,
    impactPerEuro,
  } = settings
  // Krijgt `settings` mee en opent dus geen tweede stel instellingen-listeners.
  const { unseen: ongelezenUpdates } = useUnseenUpdates(settings)
  const mainColor = '#47acc3'
  const inactiveColor = 'var(--ink)'

  // Permissions — `canView` is permissive while permissions load so the
  // menu doesn't flash sections in and out on mount.
  const { has, ready, worksIn } = usePermissions()
  const canView = (key) => !ready || has(key)
  // Onderdelen waarin de rol werkt -- puur om het menu rustiger te maken, geen
  // beveiliging. Net als `canView` permissief zolang de rollen laden, zodat het
  // menu niet halverwege verspringt.
  // AI-CONTEXT: See docs/features/rol-onderdelen.md
  const inArea = (key) => !ready || worksIn(key)

  // Firestore
  const syncs = useFirestoreNoCompagny('Synchronisations', 'Project', client ? client : '')

  // Keep the highlighted menu item in sync with the current route, so navigation
  // from outside the sidebar (e.g. the dashboard's "Aanpassen" modal) updates it too.
  useEffect(() => {
    const segment = location.pathname.split('/')[2];
    const match = MENU_ROUTE_MAP[segment];
    if (!match) return;
    setActive(match.active);
    setActiveSubItem(match.sub);
    // 'Vragenlijsten' zit onder de groep 'Onderzoeken'; sta je op een
    // vragenlijstpagina, klap die groep dan open zodat het item zichtbaar is.
    if (match.sub === 'research' || match.sub === 'questionnaires') setShowResearchChildren(true);
  }, [location.pathname, setActive, setActiveSubItem]);

  // useEffect to handle the delayed open state
  useEffect(() => {
    if (open) {
      const timeout = setTimeout(() => {
        setDelayedOpen(true);
      }, 100);
      return () => clearTimeout(timeout);
    } else {
      setDelayedOpen(false);
    }
  }, [open]);

  // Ingeklapt: een klik op een icoon brengt je naar dat onderdeel én klapt de
  // balk uit. Vóór 2026-10-01 klapte hij alleen uit, en de tester dacht dat de
  // klik niets deed — twee klikken voor één navigatie (testronde, B5).
  const openAt = (url, name) => {
    history.push(`/${client}/${url}`);
    setActive(name);
    setActiveSubItem('');
    setOpen(true);
  }

  // Function to render the inner items
  const innerItem = (Icon, url, name, state, setState) => {
    return (
      <div
        className="sidebar-title-inner-container"
        onClick={() => {
          history.push(`/${client}/${url}`);
          setActive(url);
          setState(!state);
          setActiveSubItem('');
        }}
      >
        <div className={`sidebar-title-hover-container${active === url ? ' is-active' : ''}`}>
          <Icon />
          <h3>{name}</h3>
          {state
            ?
            <KeyboardArrowDownOutlinedIcon className="expand-menu-icon" />
            :
            <ChevronRightOutlinedIcon className="expand-menu-icon" />}
        </div>
      </div>
    )
  }

  // Function to render the inner sub items
  const innerSubItem = (url, name, mainItem, premium) => {
    return (
      <div className="channel-inner-div">
        <div className='activity-meta-title-container'>
          <p
            className={activeSubItem === url ? 'is-active' : undefined}
            onClick={() => {
              history.push(`/${client}/${url}`);
              setActive(mainItem);
              setActiveSubItem(url)
            }}>
            {name}
          </p>
          {premium && subscription === 'free' &&
            <div className='premium-icon-container' onClick={() => { history.push(`/${client}/subscription`) }}>
              <Tooltip content='Premium functie' width={'20px'} height={'20px'}>
                <ArrowCircleUpOutlinedIcon />
              </Tooltip>
            </div>
          }
        </div>
      </div>
    )
  }

  // NEW: a sub-group header that can expand/collapse children
  const innerSubGroup = (name, isOpen, setIsOpen, groupKey) => {
    const isActiveGroup = activeSubItem === groupKey || (groupKey === 'research' && activeSubItem === 'questionnaires');
    return (
      <div className="channel-inner-div">
        <div
          className='activity-meta-title-container'
          onClick={() => {
            // navigate to the group root and expand/collapse
            history.push(`/${client}/${groupKey}`);
            setActive('measurementplan');
            setActiveSubItem(groupKey);
            setIsOpen(!isOpen);
          }}
          style={{ cursor: 'pointer' }}
        >
          <p className={isActiveGroup ? 'is-active' : undefined}>
            {name}
            {isOpen ? <KeyboardArrowDownOutlinedIcon /> : <ChevronRightOutlinedIcon />}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div id='left-side-bar-toggle-container'>
      <div id='closed-sidebar-icons-container' style={{ display: open ? 'none' : 'flex' }}>
        <Tooltip content='Dashboard' right='-70px'>
          <DashboardOutlinedIcon style={{ fill: active === 'dashboard' ? mainColor : inactiveColor }} onClick={() => openAt('dashboard', 'dashboard')} />
        </Tooltip>
        {impactFunctionality && inArea('impactMeten') && (
          <Tooltip content='Analyseren' right='-70px'>
            <QueryStatsOutlinedIcon style={{ fill: active === 'analysis' ? mainColor : inactiveColor }} onClick={() => openAt('analysis', 'analysis')} />
          </Tooltip>
        )}
        {/* Intelligence — zelfde gate als in het uitgeklapte menu hieronder.
            De zijbalk rendert ingeklapt en uitgeklapt als twee losse lijsten;
            een item toevoegen betekent altijd BEIDE. */}
        {isSuperAdminTenant(client) && (
          <Tooltip content='Intelligence' right='-80px'>
            <LightbulbOutlinedIcon style={{ fill: active === 'intelligence' ? mainColor : inactiveColor }} onClick={() => openAt('intelligence', 'intelligence')} />
          </Tooltip>
        )}


        {impactFunctionality && inArea('impactMeten') &&
          <>
            {canView('strategy.view') &&
              <Tooltip content='Theory of Change' right='-90px'>
                <BarChartOutlinedIcon style={{ fill: active === 'impactstrategy' ? mainColor : inactiveColor }} onClick={() => openAt('impactstrategy', 'impactstrategy')} />
              </Tooltip>
            }
            {canView('measurement.view') &&
              <Tooltip content='Meten' right='-50px'>
                <BiotechOutlinedIcon style={{ fill: active === 'measurementplan' ? mainColor : inactiveColor }} onClick={() => openAt('measurementplan', 'measurementplan')} />
              </Tooltip>
            }
          </>
        }

        {(personas === 'flex' || housevisits) && inArea('ondersteuning') && (canView('personas.view') || canView('housevisits.view')) && (
          <Tooltip content='Ondersteuning' right='-90px'>
            <GroupsOutlinedIcon style={{ fill: active === 'personas' ? mainColor : inactiveColor }} onClick={() => openAt('personasexplainer', 'personas')} />
          </Tooltip>
        )}
        {portfolio === 'block' && inArea('portfolio') && canView('portfolio.view') && (
          <Tooltip content='Portfolio' right='-65px'>
            <BusinessOutlinedIcon style={{ fill: active === 'portfolio' ? mainColor : inactiveColor }} onClick={() => openAt('portfolio', 'portfolio')} />
          </Tooltip>
        )}
        {hostName !== 'FIXtool' && inArea('rapportages') && canView('reports.view') && (
          <Tooltip content='Communiceren' right='-80px'>
            <AssessmentOutlinedIcon style={{ fill: active === 'communication' ? mainColor : inactiveColor }} onClick={() => openAt('communication', 'communication')} />
          </Tooltip>
        )}
        {/* <HandshakeOutlinedIcon style={{fill: active === 'financing' ? mainColor : inactiveColor}} onClick={() => setOpen(true)}/> */}

        {/* Updates en Prullenbak staan onderaan, los van de modules erboven.
            Eén blok en niet twee: met twee keer margin-top:auto verdeelt
            flexbox de vrije ruimte tússen de twee, en dan drijven ze uit
            elkaar in plaats van onder elkaar te staan. Zo houden ze dezelfde
            tussenruimte als de iconen erboven.

            Updates ziet iedereen; welke updates je leest hangt af van je
            modules. De prullenbak alleen met beheerrechten: wie niets mag
            aanpassen, hoort ook niets terug te kunnen halen. */}
        <div className="closed-sidebar-bottom-icon">
          {/* De badge staat hier én bij de uitgeklapte weergave hieronder:
              de balk rendert het menu twee keer.
              AI-CONTEXT: See docs/pitfalls.md#ui-sidebar-renders-its-menu-twice */}
          <Tooltip content='Updates' right='-60px'>
            <span className='sidebar-icon-with-badge'>
              <CampaignOutlinedIcon style={{ fill: active === 'updates' ? mainColor : inactiveColor }} onClick={() => openAt('updates', 'updates')} />
              <UpdatesBadge count={ongelezenUpdates} />
            </span>
          </Tooltip>

          {has('settings.view') && (
            <Tooltip content='Prullenbak' right='-70px'>
              <DeleteOutlineOutlinedIcon style={{ fill: active === 'prullenbak' ? mainColor : inactiveColor }} onClick={() => openAt('prullenbak', 'prullenbak')} />
            </Tooltip>
          )}
        </div>
      </div>

      <div className="left-sidebar-container" style={{ width: open ? '257px' : '0px' }}>
        {logo !== 'none' ?
          <div id='leftsidebar-logo-container' >
            <img
              src={logo}
              className="top-bar-logo"
              alt="logo"
              style={{ display: delayedOpen ? 'block' : 'none' }}
              onClick={() => {
                history.push(`/${client}/dashboard`);
                setActive('');
                setActiveSubItem('');
              }}
            />
          </div>
          :
          <div id='left-sidebar-company-name-container' style={{ display: delayedOpen ? 'block' : 'none' }}>
            <h2>{companyName}</h2>
          </div>
        }

        <div className="left-side-bar" style={{ display: delayedOpen ? 'block' : 'none' }}>
          <div className="channel-div">

            {/* Dashboard */}
            <div
              className="sidebar-title-inner-container"
              onClick={() => {
                history.push(`/${client}/dashboard`);
                setActive('dashboard');
                setActiveSubItem('')
              }}
            >
              <div className={`sidebar-title-hover-container${active === 'dashboard' ? ' is-active' : ''}`}>
                <DashboardOutlinedIcon />
                <h3
                >
                  Dashboard
                </h3>
              </div>
            </div>

            {/* Analyses */}
            {impactFunctionality && inArea('impactMeten') &&
              <div
                className="sidebar-title-inner-container"
                onClick={() => {
                  history.push(`/${client}/analysis`);
                  setActive('analysis');
                  setActiveSubItem('')
                }}
              >
                <div className={`sidebar-title-hover-container${active === 'analysis' ? ' is-active' : ''}`}>
                  <QueryStatsOutlinedIcon />
                  <h3
                  >
                    Analyseren
                  </h3>
                </div>
              </div>
            }

            {/* Intelligence — onderzoeksvragen met hun inzichten. Alleen voor de
                Deccos-beheertenant; dit is een weergavekeuze, de echte poort zit
                server-side op de Cloud Functions.
                AI-CONTEXT: See docs/features/intelligence-research-questions.md */}
            {isSuperAdminTenant(client) &&
              <div
                className="sidebar-title-inner-container"
                onClick={() => {
                  history.push(`/${client}/intelligence`);
                  setActive('intelligence');
                  setActiveSubItem('')
                }}
              >
                <div className={`sidebar-title-hover-container${active === 'intelligence' ? ' is-active' : ''}`}>
                  <LightbulbOutlinedIcon />
                  <h3
                  >
                    Intelligence
                  </h3>
                </div>
              </div>
            }

            {/* Impactstrategy — single page (TOC navigator). The individual
                steps are edited in-place on that page, so no submenu. */}
            {impactFunctionality && inArea('impactMeten') &&
              <>
                {canView('strategy.view') &&
                  <div
                    className="sidebar-title-inner-container"
                    onClick={() => {
                      history.push(`/${client}/impactstrategy`);
                      setActive('impactstrategy');
                      setActiveSubItem('');
                    }}
                  >
                    <div className={`sidebar-title-hover-container${active === 'impactstrategy' ? ' is-active' : ''}`}>
                      <BarChartOutlinedIcon />
                      <h3>
                        Theory of Change
                      </h3>
                    </div>
                  </div>
                }

                {/* Measurement plan */}
                {canView('measurement.view') &&
                  <>
                    {innerItem(BiotechOutlinedIcon, 'measurementplan', 'Meten', showMeasumentplan, setShowMeasumentplan)}
                    <div className="channel-items-container" style={{ display: showMeasumentplan ? 'block' : 'none' }}>
                      {innerSubItem('storytelling', 'Storytelling', 'measurementplan')}
                      {innerSubItem('events', 'Activiteiten', 'measurementplan')}

                      {/* Onderzoeken (group) with nested Vragenlijsten */}
                      {innerSubGroup('Onderzoeken', showResearchChildren, setShowResearchChildren, 'research')}
                      <div className="channel-subitems-container" style={{ display: showResearchChildren ? 'block' : 'none' }}>
                        {innerSubItem('questionnaires', 'Vragenlijsten', 'measurementplan')}
                      </div>
                    </div>
                  </>
                }
              </>
            }

            {/* Personas / Housevisits */}
            {(personas === 'flex' || housevisits) && inArea('ondersteuning') && (canView('personas.view') || canView('housevisits.view')) &&
              <>
                {innerItem(GroupsOutlinedIcon, 'personasexplainer', 'Ondersteuning', showPersonas, setShowPersonas)}
                <div className="channel-items-container" style={{ display: showPersonas ? 'block' : 'none' }}>
                  {personas === 'flex' && canView('personas.view') && innerSubItem('personas', personaTerms.plural, 'personas')}
                  {personas === 'flex' && canView('billing.view') && innerSubItem('facturatie', 'Facturatie', 'personas')}
                  {housevisits && canView('housevisits.view') && innerSubItem('housevisitsoverview', 'Huishoudens', 'personas')}
                  {canView('forms.view') && innerSubItem('intakeforms', 'Formulieren', 'personas')}
                  {housevisits && canView('housevisits.view') && innerSubItem('materials', 'Materialen', 'personas')}
                  {housevisits && canView('housevisits.view') && wervingsacties && innerSubItem('wervingsacties', 'Wervingsacties', 'personas')}
                </div>
              </>
            }

            {/* Portfolio */}
            {portfolio && portfolio === 'block' && inArea('portfolio') && canView('portfolio.view') &&
              <>
                {innerItem(BusinessOutlinedIcon, 'portfolio', 'Portfolio', showPortfolio, setShowPortfolio)}
                <div className="channel-items-container" style={{ display: showPortfolio ? 'block' : 'none' }}>
                  {innerSubItem('projects', 'Projecten', 'portfolio')}
                  {innerSubItem('projectsOverview', 'Overzicht', 'portfolio')}
                </div>
              </>
            }

            {/* Communication */}
            {hostName !== 'FIXtool' && inArea('rapportages') && canView('reports.view') &&
              <>
                {innerItem(AssessmentOutlinedIcon, 'communication', 'Communiceren', showCommunication, setShowCommunication)}
                <div className="channel-items-container" style={{ display: showCommunication ? 'block' : 'none' }}>
                  {innerSubItem('livereports2', 'Live rapportages', 'communication', true)}
                  {impactPerEuro && innerSubItem('impactinbeeld', 'Impact in beeld', 'communication', true)}
                  {syncs && syncs.length > 0 && innerSubItem('synchronisations', 'Koppelingen', 'communication')}
                  {/* Updates mailen — het verzendscherm van de updatemailing.
                      Alleen voor de Deccos-beheertenant; dit is een
                      weergavekeuze, de echte poort zit server-side op de Cloud
                      Functions (isCallerGlobalSuperAdmin bij het verzenden).
                      Als sub-item en niet als hoofditem: daarom staat er ook
                      geen icoon in de ingeklapte strip — die toont alleen
                      hoofdgroepen.
                      AI-CONTEXT: See docs/features/updates-mailing.md */}
                  {isSuperAdminTenant(client) && innerSubItem('updatesmailing', 'Updates mailen', 'communication')}
                </div>
              </>
            }

            {/* Financing (hidden) */}
            {/* {innerItem(HandshakeOutlinedIcon, 'financing', 'Financiering', showFinancing, setShowFinancing)}
            <div className="channel-items-container" style={{display: showFinancing? 'block' : 'none' }}>
              {innerSubItem('allfunds', 'Alle fondsen', 'fincancing')}
              {innerSubItem('funds', 'Mijn fondsen', 'financing')}
            </div> */}

          </div>
        </div>

        {/* Updates en Prullenbak — vastgepind onderaan de balk, onder alle
            modules. Eén blok en niet twee: met twee keer margin-top:auto
            verdeelt flexbox de vrije ruimte tússen de twee, en dan drijven ze
            uit elkaar in plaats van onder elkaar te staan.

            Updates heeft geen permissiecheck: iedereen mag de pagina zien, de
            gating zit per update op de afgenomen modules. */}
        <div className="sidebar-bottom-container" style={{ display: delayedOpen ? 'block' : 'none' }}>
          <div
            className="sidebar-title-inner-container"
            onClick={() => {
              history.push(`/${client}/updates`);
              setActive('updates');
              setActiveSubItem('');
            }}
          >
            <div className={`sidebar-title-hover-container${active === 'updates' ? ' is-active' : ''}`}>
              <CampaignOutlinedIcon />
              <h3>
                Updates
              </h3>
              <UpdatesBadge count={ongelezenUpdates} />
            </div>
          </div>

          {/* Prullenbak — onder Updates. `has` in plaats van `canView`: zolang
              de rechten laden tonen we hem niet, want een knop die later
              verdwijnt is vervelender dan een knop die even later verschijnt.
              AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading */}
          {has('settings.view') && (
            <div
              className="sidebar-title-inner-container"
              onClick={() => {
                history.push(`/${client}/prullenbak`);
                setActive('prullenbak');
                setActiveSubItem('');
              }}
            >
              <div className={`sidebar-title-hover-container${active === 'prullenbak' ? ' is-active' : ''}`}>
                <DeleteOutlineOutlinedIcon />
                <h3>
                  Prullenbak
                </h3>
              </div>
            </div>
          )}
        </div>

      </div>

      <div id='leftsidebar-toggle-item-container' >
        <div style={{ display: open ? 'block' : 'none' }} onClick={() => setOpen(false)}>
          <Tooltip content='Menu inklappen' >
            <KeyboardDoubleArrowLeftOutlinedIcon />
          </Tooltip>
        </div>
        <div style={{ display: open ? 'none' : 'block' }} onClick={() => setOpen(true)}>
          <Tooltip content='Menu uitklappen' >
            <KeyboardDoubleArrowRightOutlinedIcon />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default LeftSideBar
